import Box from "@mui/material/Box";
import "./index.scss";

const SaveTlConfirm = ({ back, type }) => {
    return (
        <Box className="save-project-confirm-component">
            <Box className="description">
               {type === 'saveTlConfirm' ? 'Your TimeLine created successful!' : 'Your project saved successfully!'}
            </Box>
            <Box className="actions">
                <button className="back-to-project" onClick={()=> back('project')}>Go back to project</button>
                <button className="back-to-app" onClick={()=> back('app')}>Go back to app</button>
            </Box>
        </Box>
    )
}

export default SaveTlConfirm;